import React from 'react';

import { useTranslation } from 'react-i18next';
import { Card, Heading, Spinner, Text, Box, VStack, HStack, useToken, Icon, Pressable } from '@gluestack-ui/themed';
import { CircleHelp } from 'lucide-react-native';
import { tasksToSections } from '../utils/tasksToSections';
import { useDialog } from '../../../common/context/DialogContext';
import TaskItemDesktop from './TaskItemDesktop';

// Level header component
const LevelHeader = ({ section }) => (
  <Text size="xs" color="$textLight900" textTransform="uppercase" fontWeight="bold" mb="$0.5">
    {section.title}
  </Text>
);

const TaskList = ({ module, tasks, currentTask, handleSelectTask, selectedModule, ...props }) => {
  const { t } = useTranslation();
  const { showDialog } = useDialog();
  const sectionedTasks = tasks ? tasksToSections(module, tasks) : [];

  const showModuleVersionHelpDialog = () => {
    showDialog({
      title: t('student.module.task-list.module-version-help-dialog.title'),
      message: t('student.module.task-list.module-version-help-dialog.description', { version: module.version }),
      buttons: [{ text: t('student.module.task-list.module-version-help-dialog.confirm'), variant: 'primary' }],
    });
  };

  return (
    <VStack>
      <Card {...props} testID="task-list" px="$6" py="$6">
        {/* <Heading size="lg" mb="$3">
          {t('student.module.task-list.title')}
        </Heading> */}
        {!tasks ? (
          <Spinner testID="spinner" selfAlign="center" />
        ) : (
          <VStack>
            {sectionedTasks.map((section) => (
              <Box key={section.level}>
                <LevelHeader section={section} />
                <VStack mb="$6">
                  {section.data.map((item) => (
                    <TaskItemDesktop
                      key={item.id}
                      task={item}
                      handleSelectTask={handleSelectTask}
                      currentTask={currentTask}
                      module={module}
                      selectedModule={selectedModule}
                    />
                  ))}
                </VStack>
              </Box>
            ))}
          </VStack>
        )}
      </Card>
      <HStack ml="$2" alignItems="center" space="sm" mt="$3">
        <Text size="2xs" color="$textLight500">
          Content Version: {module.version}
        </Text>
        <Pressable onPress={showModuleVersionHelpDialog}>
          <Icon as={CircleHelp} size="3xs" color="$textLight500" />
        </Pressable>
      </HStack>
    </VStack>
  );
};

export default TaskList;
